import { render, staticRenderFns } from "./te-koop.vue?vue&type=template&id=42a1d2de&scoped=true"
import script from "./te-koop.vue?vue&type=script&lang=js"
export * from "./te-koop.vue?vue&type=script&lang=js"
import style0 from "./te-koop.vue?vue&type=style&index=0&id=42a1d2de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a1d2de",
  null
  
)

export default component.exports